<script lang="ts" setup>
import { useClipboard } from "#imports";

const props = withDefaults(
    defineProps<{
        source?: string;
        copiedText?: string;
        keyword?: string;
        btnAttributes?: Record<string, any>;
    }>(),
    {
        keyword: undefined,
        source: "",
        copiedText: "Copied!",
        btnAttributes: () => ({
            color: "gray",
            size: "xs",
            class: "text-gray-500 font-mono p-0 text-pretty text-left",
            variant: "link",
        }),
    },
);
const sourceRef = computed(() => props.source ?? "");

const { copy, copied } = useClipboard({
    source: sourceRef,
    legacy: true,
});
</script>

<template>
    <UButton v-bind="btnAttributes" @click="copy(sourceRef)">
        <span v-if="copied">Copied!</span>
        <Mark v-else :text="sourceRef" :keyword="keyword ?? ''" />
    </UButton>
</template>
